module.exports = __webpack_public_path__ + "static/media/DESTINATION-WEDDINGS-IN-PORTUGAL-VILA-GUIA-BY-NIGHT.9b678ce7.jpg";